<template>
  <input
    :id="'type-' + type"
    :type="type"
  />
</template>

<script>
export default {
  name: "Input",
  props: ["type"]
};
</script>

<style lang="stylus" scoped>
input
  border: 1px solid #D1D1D1
  &::placeholder
    font-family: "hind"
    color: #D1D1D1
    opacity: 1
</style>
